"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Copyright = Copyright;
var jsx_runtime_1 = require("react/jsx-runtime");
function Copyright() {
    // get current date year
    var currentYear = new Date().getFullYear();
    return (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-center", children: ["Copyright \u00A9 ", currentYear] });
}
